/*
 * KimiKim x STOQ native product-button placement and state sync.
 * Shopify's visible purchase button is the source of truth.
 * STOQ keeps ownership of the native button, popup and signup workflow.
 */
(function () {
  'use strict';

  if (window.KimiStoqNativeProductPlacementInitialized) return;
  window.KimiStoqNativeProductPlacementInitialized = true;

  var HIDDEN_ATTR = 'data-kimi-stoq-availability-hidden';
  var addButtonObserver = null;
  var observedAddButton = null;
  var stoqStateObservers = [];

  function getProductSection() {
    return document.querySelector('.product-section[data-section-type="product"]');
  }

  function getAddButton() {
    var section = getProductSection();
    return section ? section.querySelector('[data-add-to-cart]') : null;
  }

  function isCurrentVariantAvailable() {
    var button = getAddButton();
    if (!button) return null;

    return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
  }

  function getNativeStoqTargets() {
    var targets = [];

    document.querySelectorAll(
      '.restock-rocket-button-product, .restock-rocket-button-float'
    ).forEach(function (button) {
      if (button.classList.contains('restock-rocket-button-collection')) return;
      if (button.closest('.grid-product')) return;

      var target = button.closest(
        '.restock-rocket-button-container, ' +
        '.restock-rocket-button-container-float-right, ' +
        '.restock-rocket-button-container-float-left'
      ) || button;

      if (targets.indexOf(target) === -1) targets.push(target);
    });

    return targets;
  }

  function placeTarget(target) {
    var addButton = getAddButton();
    if (!addButton || !target) return;

    var paymentButtons = addButton.closest('.payment-buttons');
    if (!paymentButtons) return;

    if (target.parentNode !== paymentButtons || addButton.nextElementSibling !== target) {
      addButton.insertAdjacentElement('afterend', target);
    }
  }

  function showStoqTarget(target) {
    if (target.hasAttribute(HIDDEN_ATTR)) {
      target.removeAttribute(HIDDEN_ATTR);
    }

    if (target.style.getPropertyValue('display') === 'none') {
      target.style.removeProperty('display');
    }

    if (window.getComputedStyle(target).display === 'none') {
      target.style.setProperty('display', 'block', 'important');
    }
  }

  function hideStoqTarget(target) {
    if (target.getAttribute(HIDDEN_ATTR) !== 'true') {
      target.setAttribute(HIDDEN_ATTR, 'true');
    }

    if (
      target.style.getPropertyValue('display') !== 'none' ||
      target.style.getPropertyPriority('display') !== 'important'
    ) {
      target.style.setProperty('display', 'none', 'important');
    }
  }

  function syncNativeStoq() {
    var available = isCurrentVariantAvailable();
    if (available === null) return;

    getNativeStoqTargets().forEach(function (target) {
      placeTarget(target);

      if (available) hideStoqTarget(target);
      else showStoqTarget(target);
    });

    watchStoqTargets();
  }

  function scheduleSync() {
    [0, 60, 180, 350, 550, 800, 1200].forEach(function (delay) {
      window.setTimeout(syncNativeStoq, delay);
    });
  }

  function watchAddButton() {
    var button = getAddButton();
    if (!button || button === observedAddButton) return;

    observedAddButton = button;

    if (addButtonObserver) {
      addButtonObserver.disconnect();
    }

    addButtonObserver = new MutationObserver(scheduleSync);
    addButtonObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  function watchStoqTargets() {
    stoqStateObservers.forEach(function (observer) {
      observer.disconnect();
    });
    stoqStateObservers = [];

    getNativeStoqTargets().forEach(function (target) {
      var observer = new MutationObserver(function () {
        var available = isCurrentVariantAvailable();
        if (available === null) return;

        if (available) hideStoqTarget(target);
        else showStoqTarget(target);
      });

      observer.observe(target, {
        attributes: true,
        attributeFilter: ['style', HIDDEN_ATTR]
      });

      stoqStateObservers.push(observer);
    });
  }

  function containsStoqNode(node) {
    if (!node || node.nodeType !== 1) return false;

    if (
      node.matches &&
      node.matches(
        '.restock-rocket-button-product, ' +
        '.restock-rocket-button-float, ' +
        '.restock-rocket-button-container, ' +
        '.restock-rocket-button-container-float-right, ' +
        '.restock-rocket-button-container-float-left'
      )
    ) {
      return true;
    }

    return Boolean(
      node.querySelector &&
      node.querySelector('.restock-rocket-button-product, .restock-rocket-button-float')
    );
  }

  function initialize() {
    if (!getProductSection() || !document.body) return;

    document.querySelectorAll(
      '.kimi-stoq-variant-notify, #kimi-stoq-variant-notify-modal'
    ).forEach(function (node) {
      node.remove();
    });

    watchAddButton();
    scheduleSync();

    if (document.body.dataset.kimiStoqNativePlacementObserver === 'true') return;
    document.body.dataset.kimiStoqNativePlacementObserver = 'true';

    var observer = new MutationObserver(function (mutations) {
      var foundStoqNode = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!foundStoqNode && containsStoqNode(node)) {
            foundStoqNode = true;
          }
        });
      });

      watchAddButton();

      if (foundStoqNode) {
        scheduleSync();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('variantChange', function () {
    watchAddButton();
    scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function () {
    observedAddButton = null;
    initialize();
  });
})();
